export default {
  reset_password_url: 'https://authenticator.sandbox.crossref.org/reset-password/'
}
